import { TelemetryProvider } from "@knowfully/ui.common";
import { AppDependenciesProvider } from "components/App/AppDependenciesProvider";
import ErrorBoundary from "components/ErrorBoundary";
import { useTelemetryConfig } from "hooks/useTelemetryConfig";
import ReactDOM from "react-dom/client";
import { QueryClient } from "react-query";
import { RouterProvider } from "react-router-dom";
import { router } from "router";

window.global ||= window;

const rootElement = document.getElementById("root")!;

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      retryOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

const AppWithTelemetry = () => {
  const config = useTelemetryConfig();
  return (
    <TelemetryProvider config={config}>
      <ErrorBoundary>
        <AppDependenciesProvider>
          <RouterProvider router={router} />
        </AppDependenciesProvider>
      </ErrorBoundary>
    </TelemetryProvider>
  );
};

const root = ReactDOM.createRoot(rootElement);
root.render(<AppWithTelemetry />);
